import { Link } from 'react-router-dom';

export default function SEOSection() {
  return (
    <section className="relative w-full py-24 md:py-32 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <span className="text-xs tracking-[0.3em] uppercase text-foreground-400 font-label">
          / Yoybuy Sheet Гид
        </span>

        <div className="flex flex-col lg:flex-row gap-12 mt-10">
          <div className="lg:w-[45%]"></div>

          <div className="lg:w-[55%]">
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950 leading-[1.4] mb-8"
              style={{ fontFamily: 'var(--font-heading)' }}>
              Что такое <strong>Yoybuy Spreadsheet</strong> и как использовать систему в 2026 году
            </h2>

            <div className="space-y-6 text-foreground-700 font-light leading-[1.8] text-[15px]">
              <p>
                <strong>Yoybuy Spreadsheet</strong> — это инновационная система заказа товаров из Китая, которая
                использует привычный формат электронных таблиц вместо сложных веб-форм. С её помощью вы можете
                заказывать товары с Taobao, 1688, Weidian и других китайских маркетплейсов максимально быстро
                и без ошибок.
              </p>

              <p>
                Система <strong>Yoybuy Sheet</strong> разработана специально для тех, кто ценит своё время.
                Вместо того чтобы заполнять десятки полей вручную, вы просто вносите ссылки на товары в таблицу,
                указываете необходимые параметры — и заказ автоматически обрабатывается. Это исключает
                человеческий фактор и значительно ускоряет процесс.
              </p>

              <p>
                В отличие от <strong>Kakobuy Spreadsheet</strong> и <strong>Superbuy Spreadsheet</strong>,
                система Yoybuy предлагает более интуитивный интерфейс и расширенные возможности автоматизации.
                Новички могут освоить Yoybuy Spreadsheet буквально за несколько минут, в то время как
                конкуренты требуют более глубокого погружения в интерфейс.
              </p>

              <p>
                Ключевое преимущество <strong>Yoybuy Spreadsheet</strong> — прозрачность.
                Вы всегда видите актуальную стоимость товара, комиссию агента и стоимость доставки
                до подтверждения заказа. Никаких скрытых платежей и неожиданных наценок.
              </p>

              <div className="mt-8 flex flex-col sm:flex-row gap-4">
                <Link
                  to="/article/yoybuy-spreadsheet-guide"
                  className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white font-label text-sm hover:bg-primary-600 transition-all duration-300 cursor-pointer"
                >
                  Читать полное руководство
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-sm"></i>
                  </div>
                </Link>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-full border border-foreground-300 text-foreground-700 font-label text-sm hover:bg-foreground-100/50 transition-all duration-300 cursor-pointer"
                >
                  Перейти в Yoybuy
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-external-link-line text-sm"></i>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10">
          <span className="text-[11px] text-foreground-300 font-label">• SEO статья от yoybuy.top</span>
        </div>
      </div>
    </section>
  );
}